import { actionTypes } from '../../../../types';
import searchShowTour from './searchShowTour';
import searchShowLocationsByList from './searchShowLocationsByList';
import searchShowCalendar from './searchShowCalendar';
import searchShowGlossary from './searchShowGlossary';
import searchShowArticles from './searchShowArticles';
import searchShowAreaBeacons from './searchShowAreaBeacons';
import searchShowExhibitions from './searchShowExhibitions';
import searchShowTours from './searchShowTours';
import searchShowAllArticles from './searchShowAllArticles';
export default {
	[actionTypes.searchShowTour]: searchShowTour,
	[actionTypes.searchShowLocationsByList]: searchShowLocationsByList,
	[actionTypes.searchShowCalendar]: searchShowCalendar,
	[actionTypes.searchShowGlossary]: searchShowGlossary,
	[actionTypes.searchShowArticles]: searchShowArticles,
	[actionTypes.searchShowAreaBeacons]: searchShowAreaBeacons,
	[actionTypes.searchShowExhibitions]: searchShowExhibitions,
	[actionTypes.searchShowTours]: searchShowTours,
	[actionTypes.searchShowAllArticles]: searchShowAllArticles,
};
